import { useEffect, useState } from "react";
import DesktopCustomModal from "./DesktopCustomModal";
import FileUploader from "./FileUploader";
import uploadCloudImage from "../assets/Images/uploadCloudImage.svg";
import closeIcon from "../assets/svg/closeIcon.svg";
import DateOfBirthPicker from "./DateOfBirthPicker";
import axios from "axios";
import { BASE_URL } from "../api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import SpinnerLoader from "./SpinnerLoader";
import InfoIcon from "../assets/svg/InfoIcon.svg";

const UploadCoverage = ({
  myTrips = false,
  bookingId = "",
  defaultLiabilityUIView = false,
  myTripsLiabilityUIMode = false,
  emrLiabilityUI = false,
  callFetchEstimatedEmrPricing = () => {},
  onCoverageUpdated = () => {},
  refreshCount = 0,
  historyDetails,
  setShowFullModal = () => {},
  callGetBookingHistory = () => {},
}) => {
  const [loader, setLoader] = useState(false);
  const [activeModal, setActiveModal] = useState([]);
  const [liabilityInputValues, setLiabilityInputValues] = useState({
    documentName: "",
    expiration: "",
    bookingId: bookingId ? bookingId : "",
    myTrips: myTrips ? true : false,
    emrLevel: emrLiabilityUI ? true : false,
  });
  const [liabilityCoverage, setLiabilityCoverage] = useState([]);
  const [currentLiability, setCurrentLiability] = useState(
    JSON.parse(sessionStorage.getItem("sessionCurrentLiability"))
  );

  const openModal = (modalId) => {
    setActiveModal(modalId);
  };

  const closeModal = () => {
    setShowFullModal(false);
    setActiveModal("");
    setLiabilityInputValues({
      documentName: "",
      expiration: "",
      bookingId: bookingId ? bookingId : "",
      myTrips: myTrips ? true : false,
      emrLevel: emrLiabilityUI ? true : false,
    });
  };

  const handleChangeInsuranceDateDetails = (selectedDate) => {
    setLiabilityInputValues((prev) => ({
      ...prev,
      expiration: selectedDate,
    }));
  };

  const getLiabilityDocs = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}userDocument/getLiabilityDocument`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLiabilityCoverage(response?.data?.data);
      onCoverageUpdated();
    } catch (error) {}
  };

  useEffect(
    () => {
      getLiabilityDocs();
    },
    //eslint-disable-next-line
    []
  );

  const token = sessionStorage.getItem("AccessToken");

  const addLiability = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("documentName", liabilityInputValues?.documentName);
    formData.append(
      "expiration",
      format(liabilityInputValues?.expiration, "yyyy-MM-dd HH:mm:ss")
    );
    formData.append("bookingId", liabilityInputValues?.bookingId);
    formData.append("myTrips", liabilityInputValues?.myTrips);
    formData.append("emrLevel", liabilityInputValues?.emrLevel);

    try {
      const response = await axios.post(
        `${BASE_URL}userDocument/addLiabilityDocument`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status === 200) {
        if (response?.data?.statusCode === 200) {
          //closeModal("CoverageModal");
          getLiabilityDocs();
          toast.success(response?.data?.message);

          setLiabilityInputValues({
            documentName: "",
            expiration: "",
            bookingId: bookingId ? bookingId : "",
            myTrips: myTrips ? true : false,
            emrLevel: emrLiabilityUI ? true : false,
          });

          if (myTripsLiabilityUIMode) {
            callGetBookingHistory();
          }
        } else {
          toast.error(response?.data?.message);
        }
      }

      if (emrLiabilityUI) {
        callFetchEstimatedEmrPricing();
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const handleDeleteLiability = async (liabilityID) => {
    if (liabilityID === currentLiability?.id) {
      sessionStorage.removeItem("sessionCurrentLiability");
      setCurrentLiability("");
    }
    setLoader(true);
    const payload = {
      id: liabilityID,
      bookingId: bookingId ? bookingId : "",
      myTrips: myTrips ? true : false,
    };

    try {
      const response = await axios.delete(
        `${BASE_URL}userDocument/removeLiabilityDocument`,
        {
          data: payload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        if (response?.data?.statusCode === 200) {
          toast.success(response?.data?.message);
          getLiabilityDocs();
          if (myTrips) {
            callGetBookingHistory();
          }
        } else {
          toast.error(response?.data?.message);
        }
        setLoader(false);
      }
    } catch (error) {
      console.error("Failed to delete liability:", error);
      setLoader(false);
    }
  };

  const handleLinkLiability = async (liabilityID) => {
    setLoader(true);

    const payload = {
      id: liabilityID,
      bookingId: bookingId ? bookingId : "",
    };

    try {
      const response = await axios.post(
        `${BASE_URL}userDocument/linkLiabilityDocument`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200 && response?.data?.statusCode === 200) {
        toast.success(response?.data?.message);
        getLiabilityDocs();
        callGetBookingHistory();
        closeModal("CoverageModal");
        if (emrLiabilityUI) {
          callFetchEstimatedEmrPricing();
        }
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Failed to link liability:", error);
      toast.error(error?.response?.data?.message || "Server error");
    } finally {
      setLoader(false);
    }
  };

  const [validateDateFiled, setValidateDateFiled] = useState("");

  const handleBlur = (fromDobComp) => {
    setValidateDateFiled(fromDobComp?.target?.value);
  };

  return (
    <div>
      {loader && (
        <div className="overlay">
          <div className="spinner-container">
            <SpinnerLoader />
          </div>
        </div>
      )}
      {defaultLiabilityUIView && (
        <div className="p-2 m-1 bg191916 br8 fontAntarctica">
          <div className="fontSize13 p-2">Upload Liability Coverage</div>
          <div className="px-2 fontColor5BD fontSize10">
            <ul className="liabilityUnorderList">
            <li className="m-1">
              Please upload a picture, scan or PDF of your liability coverage.
            </li>
            <li className="m-1">
              Liability coverage is mandatory when renting any vehicle, and it
              is essential to provide proof of such coverage.
            </li>
            {/* <li className="m-1">
              For short-term liability, visit{" "}
              <a
                href="https://bonzah.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="bonzah"
              >
                Bonzah.com
              </a>{" "}
              and choose “RCLI” coverage. If you frequently rent or use carshare
              services, consider a Non-Owner Vehicle policy from State Farm,
              Progressive, Allstate, or Geico for a long-term solution.
            </li> */}
            <li className="m-1">
              Due to insurance issues in New York State, Joulez is currently
              unable to sell a liability policy directly to renters. For
              short-term liability, visit{" "}
              <a
                href="https://bonzah.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="bonzah"
              >
                Bonzah.com
              </a>{" "}
              and choose “RCLI” coverage. If you frequently rent or use carshare
              services, consider a Non-Owner Vehicle policy from State Farm,
              Progressive, Allstate, or Geico for a long-term solution.
            </li>
            </ul>
          </div>
          <div>
            {currentLiability?.documentName ? (
              <div className="d-flex justify-content-between align-items-center p-2 liabilityFontSize br8">
                <div className="p-2 py-3 bg3B3936 col-6 col-lg-8 liabilityBrLeft">
                  {currentLiability?.documentName && (
                    <a
                      className=""
                      href={currentLiability.documentName}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#fff",
                      }}
                    >
                      Liabilitycoverage.pdf
                    </a>
                  )}
                </div>
                <div
                  className={`p-2 py-3 ${
                    currentLiability?.expired
                      ? "fontColor335 bg51A"
                      : "fontColor9653 bg5333"
                  } col-6 col-lg-4 text-center liabilityBrRight position-relative`}
                >
                  <div>{currentLiability?.expiryDate}</div>
                  <div className="liabilityCloseIcon">
                    <img
                      onClick={() => {
                        if (myTrips) {
                          handleDeleteLiability(currentLiability?.id);
                        } else {
                          sessionStorage.removeItem("sessionCurrentLiability");
                          setCurrentLiability("");
                        }
                      }}
                      src={closeIcon}
                      alt="closeIcon"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <button
                className="liabilityButton"
                onClick={() => {
                  openModal("CoverageModal");
                  setShowFullModal(true);
                }}
              >
                Upload
              </button>
            )}
          </div>
        </div>
      )}
      {myTripsLiabilityUIMode && (
        <div>
          <div className="mb-3">
            {historyDetails?.liabilityDocument?.documentName ? (
              <div className="d-flex justify-content-between align-items-center liabilityFontSize br8">
                <div className="px-3 py-3 bg3B3936 col-6 col-lg-8 liabilityBrLeft">
                  <div className="cursorPointer">
                    {historyDetails?.liabilityDocument?.documentName && (
                      <a
                        className=""
                        href={historyDetails?.liabilityDocument?.documentName}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#fff",
                        }}
                      >
                        Liabilitycoverage.pdf
                      </a>
                    )}
                  </div>
                </div>
                <div
                  className={`p-2 py-3 ${
                    historyDetails?.liabilityDocument?.expired
                      ? "fontColor335 bg51A"
                      : "fontColor9653 bg5333"
                  } col-6 col-lg-4 text-center liabilityBrRight position-relative`}
                >
                  <div>{historyDetails?.liabilityDocument?.expiryDate}</div>
                  <div
                    className={`liabilityCloseIcon ${
                      historyDetails?.statusMessage === "Review Pending" ||
                      historyDetails?.statusMessage === "Booking Initiated"
                        ? // historyDetails?.statusMessage === "Upcoming" ||
                          // historyDetails?.statusMessage === "Completed"
                          "d-block"
                        : "d-none"
                    }`}
                  >
                    <img
                      onClick={() =>
                        handleDeleteLiability(
                          historyDetails?.liabilityDocument?.id
                        )
                      }
                      src={closeIcon}
                      alt="closeIcon"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`d-flex justify-content-between align-items-center p-2 bg3B3936 borderRadius12 fontSize14`}
              >
                <div>
                  <div className="px-3 py-2">Liability Coverage</div>
                </div>
                <div
                  onClick={() => openModal("CoverageModal")}
                  className={`px-2 cursorPointer text-decoration-underline text-end d-flex align-items-center`}
                >
                  <div>Add Liability Coverage</div>
                  <div>
                    <span>
                      <img className="mx-2" src={InfoIcon} alt="InfoIcon" />
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {emrLiabilityUI && (
        <div>
          <div
            className="text-center cursorPointer"
            onClick={() => openModal("CoverageModal")}
          >
            Add Liability Coverage
          </div>
        </div>
      )}

      <DesktopCustomModal
        isModalOpen={activeModal === "CoverageModal"}
        closeModal={() => {
          closeModal("CoverageModal");
          sessionStorage.removeItem("sessionCurrentLiability");
          setCurrentLiability("");
        }}
        closeOnOutsideClick={false}
        modalId="AddNewCards"
        modalTitle={
          <div className="text-white p-3">Upload Liability Coverage</div>
        }
        isCloseIconRequired={true}
        modalButton=""
        modalCenter={true}
        modalClassHeight="modalHeightLiabilityDetails"
        marginBottom="marginBottomUploadCoverage"
      >
        <div>
          <div>
            {liabilityCoverage?.length > 0 &&
              liabilityCoverage?.map((liability) => {
                return (
                  <div
                    key={liability?.id}
                    onClick={() => {
                      setCurrentLiability(liability);
                      sessionStorage.setItem(
                        "sessionCurrentLiability",
                        JSON.stringify(liability)
                      );
                    }}
                    className="d-flex justify-content-between align-items-center p-2 liabilityFontSize br8"
                  >
                    <div
                      className={`${
                        currentLiability?.id === liability?.id ? "borderE1" : ""
                      } d-flex w-100 br8 cursorPointer`}
                    >
                      <div className="p-2 py-3 bg3B3936 col-6 col-lg-8 liabilityBrLeft d-flex align-items-center">
                        <input
                          onChange={() => {
                            setCurrentLiability(liability);
                            sessionStorage.setItem(
                              "sessionCurrentLiability",
                              JSON.stringify(liability)
                            );
                          }}
                          type="radio"
                          checked={
                            currentLiability?.id === liability?.id
                              ? true
                              : false
                          }
                        />
                        {liability?.documentName && (
                          <a
                            className="mx-1"
                            href={liability.documentName}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#fff",
                            }}
                          >
                            Liabilitycoverage.pdf
                          </a>
                        )}
                      </div>
                      <div
                        className={`p-2 py-3 ${
                          liability?.expired
                            ? "fontColor335 bg51A"
                            : "fontColor9653 bg5333"
                        } col-6 col-lg-4 text-center liabilityBrRight position-relative`}
                      >
                        <div>{liability?.expiryDate}</div>
                        {/* <div className="liabilityCloseIcon">
                        <img
                          onClick={() => {
                            handleDeleteLiability(liability?.id);
                          }}
                          src={closeIcon}
                          alt="closeIcon"
                        />
                      </div> */}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="px-3">
            <div className="mb-3 cursorPointer">
              <FileUploader
                onFileChange={(file) => {
                  setLiabilityInputValues((prevValues) => ({
                    ...prevValues,
                    documentName: file,
                  }));
                }}
                handleDeleteFile={() => {
                  setLiabilityInputValues((prevValues) => ({
                    ...prevValues,
                    documentName: "",
                  }));
                }}
                removePreviewImage={
                  liabilityInputValues?.documentName === "" ? true : false
                }
                fileTextMessage={
                  <div className="d-flex flex-column">
                    <div>
                      <img src={uploadCloudImage} alt="uploadCloudImage" />
                    </div>
                    <div className="mt-2">Upload PDF of the coverage</div>
                  </div>
                }
              />
            </div>
            <div className="mb-3">
              <DateOfBirthPicker
                id="expiryDate"
                minDate={new Date()}
                value={liabilityInputValues?.expiration}
                placeholder="Expiry Date"
                onDateSelect={handleChangeInsuranceDateDetails}
                handleBlur={handleBlur}
                name="liability"
              />
            </div>
            <button
              onClick={addLiability}
              className={`${
                liabilityInputValues?.documentName &&
                liabilityInputValues?.expiration &&
                validateDateFiled
                  ? ""
                  : "disabled-class"
              } p-2 bg3B3936 text-white w-100 br8 outlineNone border-0 mb-2`}
            >
              Upload
            </button>
          </div>
        </div>
        <div className="position-sticky bottom-0 z-3 px-3 bg23 pt-2">
          <button
            onClick={() => {
              if (myTrips && !emrLiabilityUI) {
                handleLinkLiability(currentLiability?.id);
              } else if (emrLiabilityUI) {
                callFetchEstimatedEmrPricing(
                  false,
                  null,
                  false,
                  false,
                  currentLiability?.id
                );
              } else {
                closeModal("CoverageModal");
              }
            }}
            className={`${
              currentLiability ? "" : "disabled-class"
            } p-2 bgCE1 text-white w-100 br8 outlineNone border-0`}
          >
            Proceed
          </button>
        </div>
      </DesktopCustomModal>
    </div>
  );
};

export default UploadCoverage;
